import { render, staticRenderFns } from "./toubiaoinform.vue?vue&type=template&id=1b45909f&scoped=true"
import script from "./toubiaoinform.vue?vue&type=script&lang=js"
export * from "./toubiaoinform.vue?vue&type=script&lang=js"
import style0 from "./toubiaoinform.vue?vue&type=style&index=0&id=1b45909f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b45909f",
  null
  
)

export default component.exports